var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useRef, useCallback } from 'react';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect';
/**
 * Persist any function between renders. Keeps it up to date if it changes.
 *
 * @param fn Function to persist
 * @returns Persisted function
 */
function useCallbackRef(fn, deps) {
    if (deps === void 0) { deps = []; }
    var ref = useRef(fn);
    useIsomorphicLayoutEffect(function () {
        ref.current = fn;
    });
    return useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-expect-error: hide this
        return (0, ref.current).apply(void 0, __spreadArray([], __read(args), false));
    }, deps);
}
export default useCallbackRef;
